import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/stms/FrontEnd/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/var/www/stms/FrontEnd/src/components/ui/accordion.tsx");
